import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore'
import { Message } from "../models/message"
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  messageCollection: AngularFirestoreCollection<Message>;
  messageDoc: AngularFirestoreDocument<Message>;
  messages: Observable<Message[]>;
  message: Observable<Message>;
  readedMessages: Observable<Message[]>;
  unreadedMessages: Observable<Message[]>;
  constructor(private afs: AngularFirestore) {
      this.messageCollection = this.afs.collection('messages', ref => ref);
   }
  //Metodo para guardar el mensaje en la coleccion de mensajes
  //El mensaje tiene que llegar con la propiedad readed en false.
  sendMessage(Sendmessage: Message){
    this.messageCollection.add(Sendmessage);
  }

  //Metodo para borrar el mensaje
  deleteMessage(id: string){
    this.messageDoc = this.afs.doc(`messages/${id}`);
    this.messageDoc.delete();
  }
  //Este metodo debe ejecutarse cuando el admin abra el mensaje.
  //Su funcion es la de marcar el mensaje como leido para el filtro.
  readMessage(id, message: Message){
    this.messageDoc = this.afs.doc(`messages/${id}`);
    message.readed = true;
    this.messageDoc.update(message);
  }
  //Devuelve todos los mensajes. 
  getAllMessages(): Observable<Message[]>{
    this.messages = this.messageCollection.snapshotChanges().pipe(map(changes => {
      return changes.map(action => {
        const data = action.payload.doc.data() as Message;
        const id = action.payload.doc.id;
        return {id, ...data};
      });
    }));
    return this.messages;
  }

  //Devuelve unicamente los mensajes que ya han sido leidos
  getReadedMessages(): Observable<Message[]>{
    this.readedMessages = this.messageCollection.snapshotChanges().pipe(map(changes=> {
      return changes.map(action => {
          const data = action.payload.doc.data() as Message;
          const id = action.payload.doc.id;
          return {id, ...data};
      });
    }));
    return this.readedMessages.pipe(map(arr => arr.filter( r => r.readed === true)));
  }
  
  //Devuelve el numero de mensajes no leidos para usar en el badge de la navbar
  getNumberUnreadedMessages(){
    this.readedMessages = this.messageCollection.snapshotChanges().pipe(map(changes=> {
      return changes.map(action => {
          const data = action.payload.doc.data() as Message;
          const id = action.payload.doc.id;
          return {id, ...data};
      });
    }));
    return this.readedMessages.pipe(map(arr => arr.filter( r => r.readed === false).length));
  }
  //Devuelve unicamente los mensajes no leidos
  getUnreadedMessages(): Observable<Message[]>{
    this.readedMessages = this.messageCollection.snapshotChanges().pipe(map(changes=> {
      return changes.map(action => {
          const data = action.payload.doc.data() as Message;
          const id = action.payload.doc.id;
          return {id, ...data};
      });
    }));
    return this.readedMessages.pipe(map(arr => arr.filter( r => r.readed === false)));
  }
  //Elimina todos los mensajes
  //No estoy seguro de que funcione
  deleteAllMessages(){
    this.messageCollection.snapshotChanges().pipe(map(changes =>{
      changes.map(action => {
        const id = action.payload.doc.id;
        this.deleteMessage(id);
      });
    }));
  }
}